import { Icon } from '@chakra-ui/react';

export const Card = (props) => (
  <Icon viewBox="0 0 80 80" fill="none" {...props}>
    <path
      d="M6.66602 36.6667L16.0214 26.1419C18.5517 23.2954 22.1784 21.6667 25.9869 21.6667H26.666"
      stroke="#008544"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.668 44.6763C29.2086 43.134 32.9014 40.8426 36.668 38.3324C45.0012 32.7786 53.3344 43.3337 45.0017 50.0001H66.668C70.35 50.0001 73.3346 47.0154 73.3346 43.3334V23.3334C73.3346 19.6515 70.35 16.6667 66.668 16.6667H33.3346C29.6527 16.6667 26.668 19.6515 26.668 23.3334V44.6763Z"
      fill="#00CD69"
    />
    <path
      d="M6.66602 65.0011L24.9994 65.0001L38.3327 55.0011C38.3327 55.0011 41.0297 53.1761 44.9994 50.0004C53.3327 43.3341 44.9994 32.7785 36.666 38.3324C29.8797 42.8551 23.3327 46.6677 23.3327 46.6677"
      stroke="#008544"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.168 28.5C34.3396 28.5 33.668 29.1716 33.668 30C33.668 30.8284 34.3396 31.5 35.168 31.5V28.5ZM71.8347 31.5H73.3347V28.5H71.8347V31.5ZM35.168 31.5H71.8347V28.5H35.168V31.5Z"
      fill="#008544"
    />
  </Icon>
);
